import React from "react";
import ActionsPopup from "../../ProfilesDetail/Table/ActionsPopup";
import schema from "../../ProfilesDetail/Table/ActionsPopup/agent_attorney_actions";

const foreign_worker_group_columns = (
  formApi,
  linkedProfiles,
  setLinkedProfiles
) => [
  {
    Header: "Profile Name",
    id: "new_profile_fw_profile_name",
    accessor: (data) => data.new_profile_fw_profile_name,
    Cell: ({ value, row: { index }, column: { id } }) => <span>{value}</span>,
    minWidth: 200,
    maxWidth: 250,
  },
  {
    Header: "Foreign Worker Name",
    id: "new_profile_fw_last",
    accessor: (data) => data.new_profile_fw_last,
    Cell: ({ row: { original } }) => {
      return (
        <span>{`${original.new_profile_fw_first} ${original.new_profile_fw_last}`}</span>
      );
    },
  },
  {
    Header: "Alien Registration Number",
    id: "new_profile_fw_alien_reg_number",
    accessor: (data) => data.new_profile_fw_alien_reg_number,
    Cell: ({ value, row: { index }, column: { id } }) => <span>{value}</span>,
    maxWidth: 250,
  },
  {
    Header: "Actions",
    id: "actions",
    accessor: "actions",
    fixedWidth: 130,
    disableSortBy: true,
    isButton: true, // removes padding and positioning
    Cell: ({ row: { original } }) => {
      return (
        <ActionsPopup
          actionsPopupSchema={schema("foreign-worker", true)}
          id={original.id}
          removeLinkedProfile={true}
          linkedProfiles={linkedProfiles}
          setLinkedProfiles={setLinkedProfiles}
          formApi={formApi}
          linkedProfilesMachineName="new_group_fw_profiles"
          removedProfilesMachineName="removed_fw_profiles"
        />
      );
    },
  },
];

export default foreign_worker_group_columns;
